import React from "react";

import {
  FiBell,
  FiGlobe,
  FiInbox,
  FiMessageSquare,
  FiTrendingUp,
  FiUserPlus,
  FiUsers,
} from "react-icons/fi";

import StatCard from "../ui/StatCard";

import {
  formatNumber,
} from "../utils/siteActivityFormatters";

export default function SiteActivityStats({
  totals,
  familyLabel,
}) {
  const warningSubtitle =
    totals.monitorWarnings > 0
      ? `${formatNumber(
          totals.monitorWarnings,
        )} surveillance(s) à vérifier`
      : `${formatNumber(
          totals.familySites,
        )} affiché(s) dans ${familyLabel}`;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-8">
      <StatCard
        icon={
          <FiGlobe
            size={20}
          />
        }
        label="Sites suivis"
        value={formatNumber(
          totals.sites,
        )}
        subtitle={
          warningSubtitle
        }
        tone={
          totals.monitorWarnings >
          0
            ? "amber"
            : "sky"
        }
        pulse={
          totals.monitorWarnings >
          0
        }
      />

      <StatCard
        icon={
          <FiTrendingUp
            size={20}
          />
        }
        label="Visites jour"
        value={formatNumber(
          totals.visitsToday,
        )}
        subtitle={
          familyLabel
        }
        tone="emerald"
      />

      <StatCard
        icon={
          <FiUsers
            size={20}
          />
        }
        label="Utilisateurs"
        value={formatNumber(
          totals.totalUsers,
        )}
        subtitle={
          totals.todayUsers >
          0
            ? `+${formatNumber(
                totals.todayUsers,
              )} aujourd’hui`
            : familyLabel
        }
        tone="violet"
      />

      <StatCard
        icon={
          <FiUserPlus
            size={20}
          />
        }
        label="Adhérents"
        value={formatNumber(
          totals.adherents,
        )}
        subtitle={
          familyLabel
        }
        tone="amber"
      />

      <StatCard
        icon={
          <FiUsers
            size={20}
          />
        }
        label="Inscrits"
        value={formatNumber(
          totals.inscrits,
        )}
        subtitle={
          familyLabel
        }
        tone="slate"
      />

      <StatCard
        icon={
          <FiBell
            size={20}
          />
        }
        label="Notifications"
        value={formatNumber(
          totals.notifications,
        )}
        subtitle="Non lues du jour sélectionné"
        tone="rose"
        pulse={
          totals.notifications >
          0
        }
      />

      <StatCard
        icon={
          <FiMessageSquare
            size={20}
          />
        }
        label="Messages"
        value={formatNumber(
          totals.messages,
        )}
        subtitle="Non lus — tous les sites"
        tone="sky"
        pulse={
          totals.messages >
          0
        }
      />

      <StatCard
        icon={
          <FiInbox
            size={20}
          />
        }
        label="Requêtes"
        value={formatNumber(
          totals.requestsPending,
        )}
        subtitle={
          totals.requestsPending >
          0
            ? `${formatNumber(
                totals.requestsPending,
              )} en attente`
            : "Aucune en attente"
        }
        tone={
          totals.requestsPending >
          0
            ? "rose"
            : "emerald"
        }
        pulse={
          totals.requestsPending >
          0
        }
      />
    </div>
  );
}